var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.customer
        ? _c(
            "q-list",
            { attrs: { "no-border": "" } },
            [
              _c(
                "q-item",
                { staticClass: "q-pa-none" },
                [
                  _c("q-item-main", {
                    attrs: {
                      label: _vm.customerName,
                      sublabel: _vm.customer.customer_number
                    }
                  }),
                  _c(
                    "q-item-side",
                    { attrs: { right: "" } },
                    [
                      _c("q-btn", {
                        attrs: {
                          icon: "close",
                          flat: "",
                          disable: _vm.disable
                        },
                        on: { click: _vm.handleCustomerDeselect }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      !_vm.customer
        ? _c(
            "q-field",
            {
              staticClass: "q-ma-none",
              attrs: { error: _vm.hasError, "error-label": _vm.errorLabel }
            },
            [
              _c(
                "q-search",
                {
                  staticClass: "no-shadow",
                  attrs: {
                    name: "customer-search",
                    "float-label": _vm.$t("expense_supplier"),
                    disable: _vm.disable,
                    color: "white",
                    clearable: ""
                  },
                  model: {
                    value: _vm.customerInput,
                    callback: function($$v) {
                      _vm.customerInput = $$v
                    },
                    expression: "customerInput"
                  }
                },
                [
                  _c(
                    "infinite-autocomplete",
                    {
                      ref: "autocomplete",
                      attrs: {
                        debounce: _vm.defaultSearchDebounce,
                        "min-characters": 0,
                        "max-results": 200,
                        "max-height": "300px"
                      },
                      on: {
                        fetch: _vm.handleInfiniteScroll,
                        search: _vm.handleSearch,
                        selected: _vm.handleSelect
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "row gutter-xs justify-center q-ma-sm" },
                        [
                          _c(
                            "q-btn",
                            {
                              staticClass: "col",
                              attrs: { color: "primary", flat: "" },
                              on: {
                                click: function($event) {
                                  _vm.handleAddCustomer("person")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("create_person")))]
                          ),
                          _c(
                            "q-btn",
                            {
                              staticClass: "col",
                              attrs: { color: "primary", flat: "" },
                              on: {
                                click: function($event) {
                                  _vm.handleAddCustomer("company")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("create_company")))]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "default-modal",
        {
          attrs: {
            name: "add-customer-modal",
            autofocus: _vm.$refs.addCustomerForm,
            successHandler: _vm.handleStoreCustomer,
            title: _vm.title,
            width: "sm"
          },
          model: {
            value: _vm.modalOpened,
            callback: function($$v) {
              _vm.modalOpened = $$v
            },
            expression: "modalOpened"
          }
        },
        [
          _c(_vm.formComponent, {
            ref: "addCustomerForm",
            tag: "component",
            attrs: {
              slot: "content",
              action: _vm.action,
              restrictToBusinessPartnerType: _vm.businessPartnerType
            },
            slot: "content",
            model: {
              value: _vm.formData,
              callback: function($$v) {
                _vm.formData = $$v
              },
              expression: "formData"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }